import {
  ORBIT_SCREEN_CUSTOMER_360,
  ORBIT_SCREEN_CUSTOMER_INSIGHTS,
  ORBIT_SCREEN_CUSTOMER_PROFILE
} from './constants';
import { TOrbit } from './i18n/TModules';

const SCREEN_LABEL_KEYS: Record<string, string> = {
  [ORBIT_SCREEN_CUSTOMER_INSIGHTS]: `${TOrbit}.context.screens.customerInsights`,
  [ORBIT_SCREEN_CUSTOMER_360]: `${TOrbit}.context.screens.customer360`,
  [ORBIT_SCREEN_CUSTOMER_PROFILE]: `${TOrbit}.context.screens.customerProfile`
};

export const getOrbitScreenLabelKey = (screen: string | undefined): string | undefined =>
  screen !== undefined && Object.prototype.hasOwnProperty.call(SCREEN_LABEL_KEYS, screen)
    ? SCREEN_LABEL_KEYS[screen]
    : undefined;
